// adapted from https://confluence.cheggnet.com/pages/viewpage.action?spaceKey=UI&title=Z-Index+Guidelines
// something about the fact that this is an enum forces us to use string numeral values rather than just numbers;
// with numbers, importing the enum anywhere results in the object containing the expected k/v pairs as well as,
// for some reason, the reverse of those k/v pairs
var zindex;

(function (zindex) {
  zindex["layout"] = "100";
  zindex["chat"] = "200";
  zindex["dropdown"] = "300";
  zindex["tooltip"] = "400";
  zindex["modal"] = "500";
  zindex["sledgehammer"] = "9999999999";
})(zindex || (zindex = {}));

export default zindex;